/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccountResource } from './';
import {
    AccountResourceFromJSON,
    AccountResourceFromJSONTyped,
    AccountResourceToJSON,
} from './';
import type { TeamResource } from './';
import {
    TeamResourceFromJSON,
    TeamResourceFromJSONTyped,
    TeamResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationManagerResource
 */
export interface OrganizationManagerResource {
    /**
     * 
     * @type {string}
     * @memberof OrganizationManagerResource
     */
    managerId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationManagerResource
     */
    countryCode?: string;
    /**
     * 
     * @type {AccountResource}
     * @memberof OrganizationManagerResource
     */
    account?: AccountResource;
    /**
     * 
     * @type {Array<TeamResource>}
     * @memberof OrganizationManagerResource
     */
    teams: Array<TeamResource>;
}

/**
 * Check if a given object implements the OrganizationManagerResource interface.
 */
export function instanceOfOrganizationManagerResource(value: object): value is OrganizationManagerResource {
    if (!('teams' in value) || value['teams'] === undefined) return false;
    return true;
}

export function OrganizationManagerResourceFromJSON(json: any): OrganizationManagerResource {
    return OrganizationManagerResourceFromJSONTyped(json, false);
}

export function OrganizationManagerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationManagerResource {
    if (json == null) {
        return json;
    }
    return {
        
        'managerId': json['managerId'] == null ? undefined : json['managerId'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'account': json['account'] == null ? undefined : AccountResourceFromJSON(json['account']),
        'teams': ((json['teams'] as Array<any>).map(TeamResourceFromJSON)),
    };
}

export function OrganizationManagerResourceToJSON(value?: OrganizationManagerResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'managerId': value['managerId'],
        'countryCode': value['countryCode'],
        'account': AccountResourceToJSON(value['account']),
        'teams': ((value['teams'] as Array<any>).map((v) => TeamResourceToJSON(v))),
    };
}

